import React, { useEffect, useState } from 'react'
import './App.css'
import { connect } from 'react-redux'
import { fetchModelsData, resetState, reviewCompleted, startFetchingData } from '../../actions/data'
import { getSelectedApproach } from '../../reducers/data'
import Approach from './Approach'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { useNavigate } from 'react-router-dom'
import SleeveEditor from './SleeveEditor/SleeveEditor'
import RiskProfiles from './RiskProfiles'
import ModelHoldings from './ModelHoldings'
import SaveConfirmation from '../App/SaveConfirmation'
// import NavigateMenu from './NavigateMenu'
import { Link } from 'react-router-dom'
import SaveProgress from './SaveProgress'
import Allocations from './Allocations'

const NavigateMenu = ({ crumbs }) => {
  return (
    <div className='breadcrumbs'>
      {crumbs.map(({ name, path, onClick, disabled }, key, arr) => (
        <span key={key} className='breadcrumb'>
          {disabled ? (
            <span>{name}</span>
          ) : (
            <Link to={path} onClick={onClick}>
              {name}
            </Link>
          )}
          {/* {'\u00A0'} */}
          {key < arr.length - 1 && '\u00A0\u00A0 >\u00A0\u00A0'}
        </span>
      ))}
    </div>
  )
}

function App(props) {
  const [currentNavCrumb, setCurrentNavCrumb] = useState('Approach')
  const [currentNavCrumbIndex, setCurrentNavCrumbIndex] = useState(0)

  const navigate = useNavigate()
  const { waiting, fetchModelsData, dataFetched, startFetchingData } = props
  const [selectedSleve, setSelectedSleve] = useState(null)

  useEffect(() => {
    if (!dataFetched) {
      startFetchingData() // Dispatch the action to set waiting to true
      fetchModelsData(props.params)
    }

    window.history.replaceState({}, '', '/')
  }, [props])


  const generateNavCrumbs = () => {
    const { approachSaved, sleeveSaved, selectedModels, savedToDB, savingInProgress, riskSelected, reviewHoldings, AllocationsDecided, reviewCompleted } = props;

    const navCrumbs = [
      {
        name: 'Approach',
        path: '/approach',
        onClick: () => {
          setCurrentNavCrumb('Approach')
          setCurrentNavCrumbIndex(0)
          props.resetState('approach')
          navigate('/approach')
          window.history.replaceState({}, '', '/')
        },
        disabled: false
      },

      {
        name: 'Holdings Editor',
        path: '/sleeve-editor',
        onClick: () => {
          setCurrentNavCrumb('Holdings Editor')
          setCurrentNavCrumbIndex(1)
          props.resetState('sleeve')
          navigate('/sleeve-editor')
          window.history.replaceState({}, '', '/')
        },
        disabled: currentNavCrumb === 'Sleeve Editor'
      },

      {
        name: 'Risk Profiles',
        path: '/risk-profiles',
        onClick: () => {
          setCurrentNavCrumb('Risk Profiles')
          setCurrentNavCrumbIndex(2)
          props.resetState('riskProfiles')
          navigate('/risk-profiles')
          window.history.replaceState({}, '', '/')
        },
        disabled: currentNavCrumb === 'Risk Profiles'
      },
      {
        name: 'Allocations',
        path: '/allocations',
        onClick: () => {
          setCurrentNavCrumb('Allocations')
          setCurrentNavCrumbIndex(3)
          props.resetState('allocations')
          navigate('/allocations')
          window.history.replaceState({}, '', '/')
        },
        disabled: currentNavCrumb === 'Allocations'
      },
      {
        name: 'Model Holdings',
        path: '/model-holdings',
        onClick: () => {
          setCurrentNavCrumb('Model Holdings')
          setCurrentNavCrumbIndex(4)
          props.resetState('model')
          navigate('/model-holdings')
          window.history.replaceState({}, '', '/')
        },
        disabled: currentNavCrumb === 'Model Holdings'
      },
      {
        name: 'Save Progress',
        path: '/save-progress',
        onClick: () => {
          setCurrentNavCrumb('Save Progress')
          setCurrentNavCrumbIndex(5)
          props.resetState('progress')
          navigate('/save-progress')
          window.history.replaceState({}, '', '/')
        },
        disabled: !savingInProgress
      },
      {
        name: 'Save Confirmation',
        path: '/save-confirmation',
        onClick: () => {
          setCurrentNavCrumb('Save Confirmation')
          setCurrentNavCrumbIndex(6)
          props.resetState('saveConfirmation')
          navigate('/save-confirmation')
          window.history.replaceState({}, '', '/')
        },
        disabled: currentNavCrumb === 'Save Confirmation'
      }
    ]

    if (savedToDB) {
      // If savedToDB is true, only return the 'Approach' navCrumb
      return navCrumbs.filter(crumb => crumb.name === 'Approach')
    }
    // use index to determine which navCrumbs to return
    return navCrumbs.filter((crumb, index) => {
      const currentNavCrumbIndex = navCrumbs.findIndex(c => c.name === currentNavCrumb);
      if (index < currentNavCrumbIndex) return true;

      if (crumb.name === 'Approach') return true;
      if (crumb.name === 'Holdings Editor') return approachSaved;
      if (crumb.name === 'Risk Profiles') return sleeveSaved;
      if (crumb.name === 'Allocations') return currentNavCrumb === 'Allocations' || currentNavCrumb === 'Model Holdings' || (sleeveSaved && riskSelected === 'yes');
      if (crumb.name === 'Model Holdings') return currentNavCrumb === 'Model Holdings' || (selectedModels && selectedModels.length > 0);
      if (crumb.name === 'Save Progress') return savingInProgress;
      if (crumb.name === 'Save Confirmation') return savedToDB;

      return false;
    });
  }

  const navCrumbs = generateNavCrumbs()
  const {
    approachSaved,
    sleeveSaved,
    selectedModels,
    savedToDB,
    savingInProgress,
    isAllocationSelected,
    riskSelected,
    reviewHoldings,
    AllocationsDecided,
    reviewCompleted,
    stepOneCompleted,
    stepTwoCompleted,
    stepThreeCompleted,
    stepFourCompleted,
    stepFiveCompleted,
    stepSixCompleted,
  } = props



  if (waiting && dataFetched === false) {
    return (
      <div className='custom-models-waiting'>
        <FontAwesomeIcon icon='circle-notch' size='2x' spin />
      </div>
    )
  } else {
    return (
      <div className='modelcustomization'>
        <div className='custom-model-content'>
          <div className='navCrumbs-container'>
            {!savingInProgress && <NavigateMenu crumbs={navCrumbs} />}
          </div>
          <div >
            {!stepOneCompleted && !stepTwoCompleted && !stepThreeCompleted && !stepFourCompleted && !stepFiveCompleted && !stepSixCompleted && < Approach />}
            {stepOneCompleted && !stepTwoCompleted && !stepThreeCompleted && !stepFourCompleted && !stepFiveCompleted && !stepSixCompleted && <SleeveEditor />}
            {stepOneCompleted && stepTwoCompleted && !stepThreeCompleted && !stepFourCompleted && !stepFiveCompleted && !stepSixCompleted && <RiskProfiles />}
            {stepOneCompleted && stepTwoCompleted && stepThreeCompleted && !stepFourCompleted && !stepFiveCompleted && !stepSixCompleted && <Allocations />}
            {stepOneCompleted && stepTwoCompleted && stepThreeCompleted && stepFourCompleted && !stepFiveCompleted && !stepSixCompleted && <ModelHoldings />}
            {stepOneCompleted && stepTwoCompleted && stepThreeCompleted && stepFourCompleted && stepFiveCompleted && !stepSixCompleted && <SaveProgress />}
            {stepSixCompleted && <SaveConfirmation />}
          </div>
        </div>
      </div>
    )
  }
}

const mapStateToProps = state => {
  return {
    waiting: state.data.waiting,
    selectedApproach: getSelectedApproach(state),
    approachSaved: state.data.approachSaved,
    sleeveSaved: state.data.sleeveSaved,
    selectedTickers: state.data.selectedTickers,
    selectedModels: state.data.selectedModels,
    savedToDB: state.data.savedToDB,
    savingInProgress: state.data.savingInProgress,
    dataFetched: state.data.dataFetched,
    isAllocationSelected: state.data.isAllocationSelected,
    riskSelected: state.data.riskSelected,
    reviewHoldings: state.data.reviewHoldings,
    AllocationsDecided: state.data.AllocationsDecided,
    reviewCompleted: state.data.reviewCompleted,
    stepOneCompleted: state.data.stepOneCompleted,
    stepTwoCompleted: state.data.stepTwoCompleted,
    stepThreeCompleted: state.data.stepThreeCompleted,
    stepFourCompleted: state.data.stepFourCompleted,
    stepFiveCompleted: state.data.stepFiveCompleted,
    stepSixCompleted: state.data.stepSixCompleted,
  }
}

const mapDispatchToProps = dispatch => ({
  fetchModelsData: params => dispatch(fetchModelsData(params)),
  resetState: stateKey => dispatch(resetState(stateKey)),
  startFetchingData: () => dispatch(startFetchingData()) // Add this line
});

export default connect(mapStateToProps, mapDispatchToProps)(App)